export enum OrderSource {
  PARTAKE_APP = 'partake-app',
  PARTAKE_WEB = 'partake-web',
  CUSTOM_APP = 'custom-app',
  CUSTOM_WEB = 'custom-web',
  POS_APP = 'pos-app',
  POS_WEB = 'pos-web',
}
